import gql from "graphql-tag";

const YIRResponse = `
        summonersRiftStats {
        avgAssists
        avgCsPerMin
        avgDeaths
        avgDragons
        avgGoldPerMin
        avgKills
        avgTowers
        avgWardsPerGame
        fastestTower
        kda
        mostDragons
    }
    howlingAbyssStats {
        avgAssists
        avgDeaths
        avgGoldPerMin
        avgKills
        kda
        uniqueChampionWins
    }
    multiKills {
        doubleKills
        pentaKills
        quadraKills
        tripleKills
    }
    allTheDamage {
        bestCsPerMin {
          championId
          csPerMin
        }
        bestDamagePerDeath {
          championId
          damagePerDeath
        }
        bestKda {
          championId
          kda
        }
        bestWinRate {
          championId
          winRate
        }
      }
      BestAndWorst {
        diedToMost {
          championId
          deaths
        }
        killedMost {
          championId
          kills
        }
        lostAgainstMost {
          championId
          loses
        }
        wonAgainstMost {
          championId
          wins
        }
      }
      mostPlayedChamps {
        roleName
        topChamps {
          championId
          gamesPlayed
          percentPlayed
          winRate
        }
      }
      positionBreakdown {
        avgCsPerMin
        avgDmgHealed
        avgDmgMitigated
        avgDmgPerMin
        avgGoldPerMin
        avgWardsPerGame
        kda
        percentPlayed
        roleName
      }
      howlingAbyssTopThree {
        championId
        gamesPlayed
        kda
        percentTeamDamage
        percentTeamGold
        winRate
        diedToMost {
          championId
          deaths
        }
        lostAgainstMost {
          championId
          loses
        }
        wonAgainstMost {
          championId
          wins
        }
        killedMost {
          championId
          kills
        }
      }
      summonersRiftTopThree {
        championId
        gamesPlayed
        kda
        percentTeamDamage
        percentTeamGold
        winRate
        diedToMost {
          championId
          deaths
        }
        killedMost {
          championId
          kills
        }
        lostAgainstMost {
          championId
          loses
        }
        wonAgainstMost {
          championId
          wins
        }
      }
      teamPlayers{
        bestKda {
          accountId
          kda
          profileIcon
          summonerName
        }
        bestWinRate{
          accountId
          winRate
          profileIcon
        summonerName
        }
        mostAssists {
          accountId
          assists
          profileIcon
          summonerName
        }
        mostGames {
          accountId
          totalGames
          profileIcon
          summonerName
        }
      }
      playerInfo {
        iconId
      }
      soloRankScore {
        rank
        tier
        wins
        losses
      }
      flexRankScore{
        rank
        tier
        wins
        losses
      }
`;

export const yearInReviewBySeason = `endOfYearReview(regionId: $regionId, summonerName: $summonerName, season: $season) {
    ${YIRResponse}
  }`;

export const YEAR_IN_REVIEW_BY_SEASON = gql`
    query YearInReview(
        $regionId: String!,
        $summonerName: String!,
        $season: Int
    ) {
        ${yearInReviewBySeason}
    }
`;

export default YEAR_IN_REVIEW_BY_SEASON;
